
export default {
  props: {
    cdnData: Array,
  },
  data() {
    return {
      isExpanded: false,
      areTitlesFloating: false,
      selectedPlan: "رایگان",
      items: ["رایگان", "استاندارد", "پیشرفته", "سازمانی"],
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.stickyHeader);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.stickyHeader);
  },
  methods: {
    formatPrice(value) {
      return String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    handleToggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    getArrayWithExpandCondition(arr) {
      if (!this.isExpanded) return arr.slice(0, 5);
      else return arr;
    },
    stickyHeader() {
      let selectedIndex = 0;

      switch (this.selectedPlan) {
        case "رایگان":
          selectedIndex = 0;
          break;
        case "استاندارد":
          selectedIndex = 1;
          break;
        case "پیشرفته":
          selectedIndex = 2;
          break;
        case "سازمانی":
          selectedIndex = 3;
          break;

        default:
          break;
      }

      const header = this.$el.querySelectorAll(".sticky-header");
      const parentDiv = this.$el.querySelectorAll(".parent-div");
      const cartContainer = this.$el.querySelectorAll(".cart-container");

      if (
        !header[selectedIndex] ||
        !parentDiv[selectedIndex] ||
        !cartContainer[selectedIndex] ||
        !this.isExpanded
      ) {
        this.isSticky = false;
        return;
      }

      const parentDivRect = parentDiv[selectedIndex].getBoundingClientRect();
      const cartContainerRect =
        cartContainer[selectedIndex].getBoundingClientRect();

      if (
        +parentDivRect.y.toFixed(0) <= -133 &&
        +parentDivRect.y.toFixed(0) >=
          (Math.abs(cartContainerRect.height) + 248 - 300) * -1
      ) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },
  },
  computed: {
    freePlanValues() {
      const planItems = this.cdnData[0].description.planItems;
      const values = [];

      planItems.forEach((item) => {
        return item.items.forEach((i) => {
          values.push(i);
          return;
        });
      });

      return values;
    },
    standardPlanValues() {
      const planItems = this.cdnData[1].description.planItems;
      const values = [];

      planItems.forEach((item) => {
        return item.items.forEach((i) => {
          values.push(i);
          return;
        });
      });

      return values;
    },
    advancePlanValues() {
      const planItems = this.cdnData[2].description.planItems;
      const values = [];

      planItems.forEach((item) => {
        return item.items.forEach((i) => {
          values.push(i);
          return;
        });
      });

      return values;
    },
    enterprisePlanValues() {
      const planItems = this.cdnData[3].description.planItems;
      const values = [];

      planItems.forEach((item) => {
        return item.items.forEach((i) => {
          values.push(i);
          return;
        });
      });

      return values;
    },
  },
};
